import { post } from "../../api/ajax.js";
import * as utils from "../../utils/utils.js"
import * as types from '../mutation-types.js'

//全局状态

const state = {
  mapList: [], //查询单个轨迹数据
  userInfo: {}, //用户信息
  intoverDate: [],//存储驾驶舱筛选运力看板时间
  intoverListDate:[],//存储驾驶舱运单看板时间
  intoverMonDate:[],//存储驾驶舱财务看板时间
  intoverDeliverListDate:[],//存储驾驶舱货源看板时间
  menus: [], //菜单
  routes: [],//过滤后的菜单
  tabs: [],//打开的菜单
  cached: [],//缓存列表
  cachedViews: [], //需要keep-alive的页面组件的name列表
  isSetRoute: [], //已经显示的路由栈
  token: '',
  tableAddressTree: [], //省市区镇数据
};

//getters
const getters = {

};

const mutations = {
  login(state, user) {
    state.userInfo = user
  },
  setIntoverDate(state, date) {
    state.intoverDate = date
  },
  setIntoverListDate(state, date) {
    state.intoverListDate = date
  },
  setIntoverMonDate(state, date) {
    state.intoverMonDate = date
  },
  setIntoverDeliverListDate(state, date){
    state.intoverDeliverListDate = date
  },
  menu(state, menus) {
    state.menus = menus
  },
  initMenu(state, routes) {
    state.routes = routes
  },
  token(state, token) {
    state.token = token;
  },
  tabs(state, tabs) {
    tabs = tabs ? tabs : [];
    localStorage.setItem("tabs", JSON.stringify(tabs))
    state.tabs = tabs;
  },
  cached(state, cached) {
    state.cached = cached;
  },
  cachedViews(state, cachedViews) {
    state.cachedViews = cachedViews
  },
  isSetRoute(state, isSetRoute) {
    state.isSetRoute = isSetRoute;
  },
  mapList(state, mapList) {
    // console.log(state, mapList);
    state.mapList = mapList;    
  },

  [types.FIND_TO_TREE](state, tree) {
    state.tableAddressTree = tree;
  },
};
// actions
const actions = {
  fetchTree({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      post("/api/md/base/district/findToTree", params)
      .then(res => {
        if (res.length > 0 && res) {
          var json = JSON.parse(res);
          var tree = utils.findToTree(json);
          localStorage.setItem("tableAddressTree", JSON.stringify(tree));
          resolve(tree)
        }
      }).catch(err => {
        reject(err)
      })
    })
   
  },
  fetchAreaManagerTree({commit, state}, params) {
    return new Promise((resolve, reject) => {
      post("/api/md/base/district/findToTree", params)
      .then(res => {
        if (res.length > 0 && res) {
          var json = JSON.parse(res);
          var tree = utils.findToChooseTree(json);
          localStorage.setItem("fetchAreaManagerTree", JSON.stringify(tree));
          resolve(tree)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
};

export default {
  // namespaced: true,
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sharing.js